import React from 'react';
import { humanize } from 'underscore.string';
import i18next from 'i18next';

function wrapLineClamp(cell) {
  return (
    <div className="line-clamp" title={cell}>
      {typeof cell === "object" ? JSON.stringify(cell) : cell}
    </div>
  );
}

export const getChangesColumns = () => {
  return [
    {
      dataField: 'key',
      text: i18next.t('ATTRIBUTE'),
      sort: true,
      type: 'raw',
      defaultSorted: true,
      formatter: (cell) => {
        const pieces = cell.split('.');
        const lastIndex = pieces.length - 1;
        const labels = pieces.reduce((tokens, piece, index) => {
          const row = index + 1;
          if (row % 2 === 0) {
            const label = `${pieces[index - 1]}.${piece}`;
            return tokens.concat(label);
          }
          if (index === lastIndex) {
            return tokens.concat(piece);
          }
          return tokens;
        }, []);
        return (
          <dl className="line-clamp" title={cell}>
            {labels.map((token, i) => (
              <dd className="text-sm" key={i}>
                {token}
              </dd>
            ))}
          </dl>
        );
      },
    },
    {
      dataField: 'before',
      text: i18next.t('BEFORE'),
      sort: true,
      formatter: (cell) => {
        return wrapLineClamp(cell);
      },
    },
    {
      dataField: 'after',
      text: i18next.t('AFTER'),
      sort: true,
      formatter: (cell, row) => {
        if (row.key.endsWith('reference_numbers')) {
          const { name, value } = cell;
          return (
            <div className="mb-2">
              <span className="block font-medium text-gray-500 text-sm">
                {name}
              </span>
              <span className="block text-gray-900 text-sm mt-1">{value}</span>
            </div>
          );
        }

        if (
          row.key === 'line_item_charges' ||
          (typeof cell === 'object' && !Array.isArray(cell))
        ) {
          return (
            <div>
              {Object.keys(cell).map((key) => (
                <div className="mb-2">
                  <span className="block font-medium text-gray-500">
                    {humanize(key)}
                  </span>
                  <span className="block text-gray-900 text-sm mt-1">
                    {cell[key]}
                  </span>
                </div>
              ))}
            </div>
          );
        }

        return wrapLineClamp(cell);
      },
    },
    {
      dataField: 'system',
      text: i18next.t('CURRENT'),
      sort: true,
      formatter: (cell, row) => {
        if (row.key.endsWith('reference_numbers') && Array.isArray(cell)) {
          return (
            <dl className="">
              {cell.map((item, index) => (
                <div className="mb-1" key={index}>
                  <dt className="text-sm font-medium text-gray-500 line-clamp">
                    {item.name}
                  </dt>
                  <dd
                    className="text-sm text-gray-900 line-clamp"
                    title={item.value}
                  >
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          );
        }

        if (row.key.includes('equipment') && Array.isArray(cell)) {
          return (
            <dl className="">
              {cell.map((item, index) => (
                <div className="mb-1" key={index}>
                  <dd
                    className="text-sm text-gray-900 line-clamp"
                    title={item.equipment_id}
                  >
                    {item.equipment_id}
                  </dd>
                </div>
              ))}
            </dl>
          );
        }

        return wrapLineClamp(cell);
      },
    },
  ];
};
